import { navigate } from 'vike/client/router';

import { authToken } from '@/renderer/utils/useMe';

/**
 * "Back" for the phone page header's chevron (#2142): go back in history when
 * there is an earlier entry inside this app session, otherwise to a sensible root.
 *
 * `history.length` cannot tell those apart (it counts entries from other sites
 * and is never reduced), so this compares Vike's per-entry timestamp against
 * the entry the app booted on: every entry pushed since then is newer. On the
 * boot entry itself (a deep link, a push notification, a cold app launch)
 * `history.back()` would leave the app or do nothing, so it navigates instead:
 * to the release center when signed in, the public archive when not (the
 * release center is guarded and would just bounce a visitor to /signin).
 */

let bootEntry: number | undefined;

function entryTimestamp(): number | undefined {
  const ts = window.history.state?.vike?.timestamp;
  return typeof ts === 'number' ? ts : undefined;
}

/** Call once on the first client render (renderer/PageLayout.tsx). */
export function markBootHistoryEntry() {
  if (bootEntry === undefined) {
    bootEntry = entryTimestamp() ?? 0;
  }
}

export function hasInAppHistory() {
  const current = entryTimestamp();
  return bootEntry !== undefined && current !== undefined && current > bootEntry;
}

export function goBackInApp() {
  if (hasInAppHistory()) {
    window.history.back();
    return;
  }

  void navigate(authToken() ? '/release-center' : '/archive');
}
